import { NoteViewModel } from "./GetMemberByFingerprintQuery/NoteViewModel"
import AssociatedMemberViewModel from "./AssociatedMemberViewModel"

interface MemberViewModel {
    Id?: string;
    Address1: string;
    Address2: string;
    AddressPicture: string;
    DataProtectionAgreed: boolean;
    DateOfBirth: string;
    Email: string;
    Firstname: string;
    HoldInformationAgreed: boolean;
    MarketingOptIn: boolean;
    MemberPhoto: string;
    PhoneNumber: string;
    Postcode: string;
    Surname: string;
    Thumbprints: string[];
    Town: string;
    Loyalty: number;
    IsGuest: boolean;
    IsSwinging: boolean;
    IsFetish: boolean;
    IsBlocked: boolean;
    MembershipType: string;
    Notes: NoteViewModel[];
    IsSignedIn: boolean;
    HasFingerprint: boolean;
    AssociatedMembers?: AssociatedMemberViewModel[];
    MembershipId?: string;
    IsDeleted: boolean;
    PaidMembership: boolean;
    MembershipDue?: Date;
    KeyNumber?: number
}

function DefaultMemberViewModel(): MemberViewModel {
    return {
        Address1: "",
        Address2: "",
        AddressPicture: "",
        DataProtectionAgreed: false,
        DateOfBirth: "",
        Email: "",
        Firstname: "",
        HoldInformationAgreed: false,
        MarketingOptIn: false,
        MemberPhoto: "",
        PhoneNumber: "",
        Postcode: "",
        Surname: "",
        Thumbprints: [],
        Town: "",
        Loyalty: 0,
        IsGuest: false,
        IsSwinging: true,
        IsFetish: false,
        IsBlocked: false,
        MembershipType: "",
        Notes: [],
        IsSignedIn: false,
        HasFingerprint: false,
        IsDeleted: false,
        PaidMembership: false,
    }
}

export { DefaultMemberViewModel }
export type { MemberViewModel }
